import styles from './style.postcss';

import React from 'react';
import { Link } from 'react-router';
import classnames from 'classnames';
import { testClass } from 'omni-common-ui';
import PropTypes from 'prop-types';

const SubNav = (props) => {
  if (! props.items) return null;
  return <div className={classnames(styles.SubNav, props.className)}>
    <ul className={styles.SubNav_mainContent}>
      {props.items.map((item) => {
        const linkTitle = item.text && item.text.replace(/\s+|'|&/g, '');
        const className = classnames(styles.SubNav_mainContent_item,
          testClass(`${linkTitle}-link`),
          {
            [styles.__active]: item.isActive,
          });
        const pureTextClassName = classnames({
          [styles.SubNav_mainContent_item_disabled]: item.isDisabled,
        });
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        return <li key={item.text}
            className={className}
            onClick={() => item.onClick && item.onClick()}>
          {item.href ?
            <Link to={item.href}
                draggable={false}>
              {item.text}
            </Link> :
            <span className={pureTextClassName}>
              {item.text}
            </span>}
        </li>;
      })}
    </ul>
  </div>;
};

SubNav.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      onClick: PropTypes.func,
      isActive: PropTypes.bool,
      isDisabled: PropTypes.bool,
    })),
};

export default SubNav;



// WEBPACK FOOTER //
// ./components/TabNav/SubNav/index.jsx